import { HiXMark } from "react-icons/hi2";

export const CloseIcon = ({ width, height, color, ...props }) => (
  <HiXMark
    size={width || height || 24}
    color={color || "currentColor"}
    {...props}
  />
);
